// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1T_85","buttons":"Footer_buttons__3gLUj"};